import { useQueryClient } from '@tanstack/react-query'

import { useIndividualsServicePostV1IndividualsByIndividualIdDocumentsByDocumentIdCommit } from '../client/queries'
import { useIndividualsServiceGetV1IndividualsByIndividualIdKey } from '../client/queries/common'

export const useCommitDocument = () => {
  const queryClient = useQueryClient()

  return useIndividualsServicePostV1IndividualsByIndividualIdDocumentsByDocumentIdCommit({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useIndividualsServiceGetV1IndividualsByIndividualIdKey],
      })
    },
  })
}
